import React from 'react';
import { SortableElement } from 'react-sortable-hoc';
import { Card } from '@material-ui/core';
import { getSecondary } from '../styles/colors';

const DraggableBlock = SortableElement(props => (
	<Card
		style={{
			opacity: 1,
			color: getSecondary(),
			display: 'flex',
			alignItems: 'center',
			padding: '0.5rem',
			height: '2rem',
			border: `2px solid ${getSecondary()}`,
			listStyleType: 'none',
			borderRadius: '4px',
			cursor: 'grab',
			marginTop: '0.5em'
		}}
		className="draggable"
	>
		{props.value}
	</Card>
));

export default DraggableBlock;
